import { render, staticRenderFns } from "./Comp66t3.vue?vue&type=template&id=3fc3871e&scoped=true&"
import script from "./Comp66t3.vue?vue&type=script&lang=js&"
export * from "./Comp66t3.vue?vue&type=script&lang=js&"
import style0 from "./Comp66t3.vue?vue&type=style&index=0&id=3fc3871e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc3871e",
  null
  
)

export default component.exports